"use client";

import { c as _c } from "react/compiler-runtime";
import type { Offer } from "@local/offer/src/types";
import { cn } from "@local/utils/src/cn";
import { useForm } from "react-hook-form";
import { Button } from "../../uiv7/Button";
import { ContentBlock } from "../../ui/ContentBlock";
import { mailerSignupAction } from "./action";
export interface MailerSignupProps {
  content: Offer.MailerSignup;
  channel: string;
}
interface FormValues {
  terms: string;
  email: string;
}
export const MailerSignup = t0 => {
  const $ = _c(14);
  const {
    content,
    channel
  } = t0;
  const {
    register,
    handleSubmit,
    formState: t1
  } = useForm();
  const {
    isSubmitting,
    errors,
    isSubmitted
  } = t1;
  let t2;
  if ($[0] !== channel) {
    t2 = async t3 => {
      const {
        email
      } = t3;
      await mailerSignupAction(email, channel);
    };
    $[0] = channel;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const submit = t2;
  let t3;
  if ($[2] !== content.headline) {
    t3 = <h3 className="text-h3 leading-heading-tight mb-8 w-5/6 text-center font-semibold">{content.headline}</h3>;
    $[2] = content.headline;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== errors || $[5] !== handleSubmit || $[6] !== isSubmitted || $[7] !== isSubmitting || $[8] !== register || $[9] !== submit) {
    t4 = isSubmitted ? <p>Thank you for registering! You'll shortly receive a confirmation email from us.</p> : <form onSubmit={handleSubmit(submit)} className="w-full text-center"><div className="mb-3 flex flex-col items-center justify-center gap-4 md:flex-row"><div className="relative w-5/6"><div className="absolute -top-10 flex w-full justify-center">{errors && (errors.email || errors.terms) && <div className={cn("text-Color__Text__Problem z-10 w-fit rounded-md bg-red-200 px-3 py-1 shadow-md transition-all", "[&_.ErrorTooltip]:z-10", "[&_.ErrorTooltip]:hover:absolute [&_.ErrorTooltip]:hover:bottom-0 [&_.ErrorTooltip]:hover:left-1/2 [&_.ErrorTooltip]:hover:z-0 [&_.ErrorTooltip]:hover:h-3 [&_.ErrorTooltip]:hover:w-3 [&_.ErrorTooltip]:hover:translate-x-[-50%] [&_.ErrorTooltip]:hover:translate-y-[50%] [&_.ErrorTooltip]:hover:rotate-45 [&_.ErrorTooltip]:hover:transform [&_.ErrorTooltip]:hover:bg-red-200 [&_.ErrorTooltip]:hover:shadow-2xs [&_.ErrorTooltip]:hover:content-[\"\"]")}>{errors.email?.message}{errors.terms?.message}</div>}</div><input type="email" required={true} aria-required={true} aria-label="Email Address" {...register("email", {
            required: true
          })} placeholder="Enter your email address" className="border-Color__Border__Input border-Width__Border__Input h-12 w-full rounded-lg bg-white px-4 text-center text-base placeholder-gray-500 md:text-lg" /></div><Button type="submit" disabled={isSubmitting} className="w-full max-w-[360px]">{isSubmitting ? "Signing you up..." : "Sign Up Now"}</Button></div><div className="flex flex-row items-center justify-center md:flex-row"><input aria-label="agree" aria-required={true} type="checkbox" {...register("terms", {
          required: true
        })} defaultChecked={true} className="mr-2 mb-2 h-5 w-5 md:mb-0" required={true} /><label htmlFor="agree">I agree to receive promotional marketing and emails from{" "}<span className="font-semibold">BÆRSkin Tactical Supply Co.</span></label></div></form>;
    $[4] = errors;
    $[5] = handleSubmit;
    $[6] = isSubmitted;
    $[7] = isSubmitting;
    $[8] = register;
    $[9] = submit;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <ContentBlock className="mx-auto mb-4"><div className="mx-4 flex flex-col items-center justify-center rounded-xl bg-gray-100 px-16 py-10 lg:mx-8">{t3}{t4}</div></ContentBlock>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};